module.exports = __webpack_public_path__ + "pl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pl.svg
// module id = 1015
// module chunks = 0